// Pure selection state for the Hyperliquid multi-sub-account picker.
// Simpler than Derive's: no createCount (HL sub-accounts are created on
// HL's own UI, not through this feature), and no "self slot" (the anchor
// never takes a slot from this flow — every selection here spawns a brand
// new sibling account). Zero selections is always valid: submitting the
// picker with nothing chosen finishes onboarding identically to today's
// single-account outcome.

export interface HlSelectionState {
  selected: string[]
}

export function empty(): HlSelectionState {
  return { selected: [] }
}

export function toggleSubaccount(
  state: HlSelectionState,
  address: string,
  info: { alreadyLinked: boolean },
  maxSlots: number
): HlSelectionState {
  if (info.alreadyLinked) return state
  if (state.selected.includes(address)) {
    return { selected: state.selected.filter((existing) => existing !== address) }
  }
  if (state.selected.length >= maxSlots) return state
  return { selected: [...state.selected, address] }
}

// Authoritative submit gate. Unlike Derive's canSubmit, zero selections is
// ALWAYS submittable — that's the "picker is required-shown but
// selection-optional" contract (see the design doc's Decisions section).
export function canSubmit(state: HlSelectionState, remainingSlots: number): boolean {
  return state.selected.length <= remainingSlots
}
